import { jsxs as d, jsx as i } from "react/jsx-runtime";
import { memo as o } from "react";
import { Popconfirm as l, Tooltip as h, Button as c } from "antd";
import { R as f } from "../../../DeleteOutlined-BpfKCRGu.js";
const x = {
  title: "確認刪除嗎?",
  okText: "確認",
  cancelText: "取消"
}, t = ({
  popconfirmProps: a,
  type: r = "icon",
  buttonProps: e,
  tooltipProps: n
}) => {
  const m = {
    ...x,
    ...a
  };
  return n ? /* @__PURE__ */ d(l, { ...m, children: [
    r === "icon" && /* @__PURE__ */ i(h, { ...n, children: /* @__PURE__ */ i(
      c,
      {
        danger: !0,
        type: "text",
        icon: /* @__PURE__ */ i(f, {}),
        ...e
      }
    ) }),
    r === "button" && /* @__PURE__ */ i(c, { type: "primary", danger: !0, ...e, children: (e == null ? void 0 : e.children) ?? "刪除" })
  ] }) : /* @__PURE__ */ d(l, { ...m, children: [
    r === "icon" && /* @__PURE__ */ i(c, { danger: !0, type: "text", icon: /* @__PURE__ */ i(f, {}), ...e }),
    r === "button" && /* @__PURE__ */ i(c, { type: "primary", danger: !0, ...e, children: (e == null ? void 0 : e.children) ?? "刪除" })
  ] });
}, R = o(t);
export {
  R as PopconfirmDelete,
  t as PopconfirmDeleteComponent
};
